import React, {
    useCallback,
    useEffect, useMemo,
    useState
} from "react";
import axios from "axios";
import {
    useParams
} from "react-router-dom";

import Loading from "../../components/Loading";
import EventBanner from "../../components/event/EventBanner";
import EventTintLinkButton from "../../components/event/EventTintLinkButton";
import DateFormatter from "../../components/DateFormatter";
import moment from "moment";
import { getEventParticipationSubmissionState } from "../../utilities/eventParticipationSubmissionState";

function EventParticipationSubmissionEmbedPage() {
    const params = useParams();
    const [event, setEvent] = useState(null);
    const [error, setError] = useState(null);

    const getEvent = useCallback(async () => {
        setEvent(null);
        setError(null);
        try {
            const response = await axios.post("/getEvent", {
                eventId: params.eventId,
            });
            setEvent(response.data.event);
        } catch(requestError) {
            console.error(requestError);
            setError("Er is iets fout gegaan. Probeer het later opnieuw.");
        }
    }, [params]);

    useEffect(() => {
        getEvent();
    }, [getEvent]);

    useEffect(() => {
        // Hide scrollbars if not needed.
        document.body.style.overflow = "auto";
    }, []);

    const startDate = useMemo(() => event?.startDate ? moment(event.startDate) : null, [event]);
    const endDate = useMemo(() => event?.endDate ? moment(event.endDate) : null, [event]);
    const {
        enabled: participationSubmissionsEnabled,
        open: participationSubmissionsOpen,
    } = getEventParticipationSubmissionState(event);

    if (error) {
        return (
            <div className="background-gray">
                <div className="d-flex flex-column justify-content-center w-100">
                    <div className="alert alert-danger m-4">{error}</div>
                </div>
            </div>
        );
    }
    if (!event) {
        return (
            <div className="background-gray">
                <div className="d-flex flex-column justify-content-center w-100">
                    <Loading />
                </div>
            </div>
        );
    }

    return (
        <div className="background-gray">
            <div className="d-flex flex-column justify-content-center w-100">
                <EventBanner
                    event={event}
                    small
                    hideDescription
                />
                <div
                    className="container text-white orbitron"
                    style={{
                        paddingLeft: "40px",
                        paddingRight: "40px",
                        paddingTop: "20px",
                    }}
                >
                    <h2>
                        Inschrijving {event.name}
                    </h2>
                    { startDate && endDate && (
                        <p className="h4 text-muted">
                            { startDate.isSame(endDate, "day") ? (
                                <DateFormatter date={event.startDate} format="DD MMMM YYYY" />
                            ) : startDate.year() === endDate.year() ? (
                                startDate.month() === endDate.month() ? (
                                    <React.Fragment>
                                        <DateFormatter date={event.startDate} format="DD" /> - <DateFormatter date={event.endDate} format="DD MMMM YYYY" />
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <DateFormatter date={event.startDate} format="DD MMMM" /> - <DateFormatter date={event.endDate} format="DD MMMM YYYY" />
                                    </React.Fragment>
                                )
                            ) : (
                                <React.Fragment>
                                    <DateFormatter date={event.startDate} format="DD MMMM YYYY" /> - <DateFormatter date={event.endDate} format="DD MMMM YYYY" />
                                </React.Fragment>
                            )}
                        </p>
                    )}
                    <div className="mt-4">
                        {participationSubmissionsEnabled && participationSubmissionsOpen ? (
                            <EventTintLinkButton
                                tintColor={event?.tintColor}
                                buttonTextColor="white"
                                href={`/event/${event.id}/participation-submission`}
                                size="lg"
                            >
                                Start your engine!
                            </EventTintLinkButton>
                        ) : participationSubmissionsEnabled ? (
                            <>
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-lg"
                                    disabled
                                >
                                    Inschrijvingen gesloten
                                </button>
                                <p className="text-muted mt-3 mb-0">
                                    Aanmeldingen voor dit evenement zijn momenteel gesloten.
                                </p>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(EventParticipationSubmissionEmbedPage);
